import { LOCALES } from 'i18n/locales';

export const tooltipIntl = {
    [LOCALES.ENGLISH]: {
        'tooltip.dismiss': 'Dismiss'
    },
    [LOCALES.WELSH]: {
        'tooltip.dismiss': '[Dismiss]'
    }
};
